import React, {useEffect, useState} from 'react'
import {BorderHorizontalOutlined, BorderLeftOutlined, BorderRightOutlined} from '@ant-design/icons';

import {
    Checkbox,
    Col,
    Form,
    Input,
    Layout,
    Menu,
    MenuProps,
    message,
    Modal,
    Radio,
    Row,
    Tabs,
    TabsProps,
    Typography
} from 'antd';
import {fetchBackendToken, fetchBackendTokenStream} from "./utils/backend"
import {useLocation, useNavigate} from "react-router-dom"
import {ReactComponent as TitleMedusa} from "./icons/medusa.svg"
import {CustomSider} from './components/LayoutWrapper';
import {ChatInput, ChatMessages} from './components/Chat';
import CustomTable from "./components/CustomTable"

const {TextArea} = Input;
const {Title} = Typography
const {Content} = Layout

const displayOptions = [
    {
        label: <BorderRightOutlined/>,
        value: 'right'
    },
    {
        label: <BorderHorizontalOutlined/>,
        value: 'center'
    },
    {
        label: <BorderLeftOutlined/>,
        value: 'left'
    },
];


function useNavigateHome(page_link = '') {
    const location = useLocation()
    let page_title = location.pathname.substring(1)
    const navigate = useNavigate()
    console.log({page_title})

    useEffect(() => {
        if (page_title !== page_link) {
            console.log('redirecting')
            navigate(page_link)
        }
    }, [page_title])
}


const App: React.FC = () => {
    useNavigateHome()
    const title = 'Medusa'

    const [messages, setMessages] = useState<Array<any>>([])
    const [prompt, setPrompt] = useState<string>('')
    const [data, setData] = useState<any>(null)
    const [schema, setSchema] = useState<any>(null)
    const [categories, setCategories] = useState<any>(null)
    const [display, setDisplay] = useState('center');
    const [scenarioKey, setScenarioKey] = useState('null');
    const [scenariosKeys, setScenariosKeys] = useState([]);
    // todo: move to firestore? state seems inconsistent
    const [sampling, setSampling] = useState(true)
    const [showModalDeleteScenario, setShowModalDeleteScenario] = useState<boolean>(false)
    const [showModalEditScenario, setShowModalEditScenario] = useState<boolean>(false)

    const [formEditScenario] = Form.useForm()


    async function getData() {
        const data = await fetchBackendToken('get_data');
        setData(data)

        const schema = await fetchBackendToken('get_data?filename=schema.csv')
        setSchema(schema)

        const categories = await fetchBackendToken('get_data?filename=categories.csv')
        setCategories(categories)
    }


    async function fetchServerSetup() {
        setMessages([])
        setScenarioKey('null')
        const data = await fetchBackendToken('server_setup')
        if (data)
            await fetchScenariosKeys()
    }

    async function fetchScenariosKeys() {
        const scenariosKeys = await fetchBackendToken('get_scenarios_keys')
        if (scenariosKeys)
            setScenariosKeys(scenariosKeys)
    }

    async function fetchScenario(scenarioKey: string) {
        setScenarioKey(scenarioKey)
        const scenario = await fetchBackendToken(`get_scenario?scenario_key=${scenarioKey}`)
        const tmpMessages = scenario.messages
        setMessages(tmpMessages)

    }

    async function deleteScenario(scenario_key: string) {
        if (scenariosKeys.length === 1) {
            message.error('You must have at least one scenario')
        } else {
            await fetchBackendToken(`delete_scenario?scenario_key=${scenario_key}`,
                {method: 'DELETE'})
            await fetchServerSetup()
        }
    }

    async function editScenario(old_scenario_key: string, new_scenario_key: string) {
        await fetchBackendToken(`edit_scenario?old_scenario_key=${old_scenario_key}&new_scenario_key=${new_scenario_key}`,
            {method: 'POST'})
        await fetchScenario(new_scenario_key)

    }


    useEffect(() => {
        getData()
        fetchServerSetup()
    }, [])

    const menuItems: MenuProps['items'] = [
        {
            label: "New chat",
            key: "new-chat",
            onClick: fetchServerSetup

        },
        {
            label: <Checkbox
                // help="Sample from the model"
                checked={sampling}
                onChange={(value) => setSampling(value.target.checked)}

            >Sampling</Checkbox>,
            key: "sampling",
            // onClick: fetchServerSetup

        },
        {
            label: "Display",
            key: "display",
            children: [
                {
                    label: <Radio.Group
                        options={displayOptions}
                        onChange={
                            (value) =>
                                setDisplay(value.target.value)
                        }
                        value={display}
                        optionType="button"
                        buttonStyle="solid"
                    />,
                    key: "display_radio"
                }
            ]
        },
        {
            label: "Chat history",
            key: "chat-history",
            children: scenariosKeys.map(
                (key) => ({
                    label: key,
                    key: key,
                    onClick: () => {
                        fetchScenario(key)
                    }
                })),
            disabled: scenariosKeys.length === 0


        },
        {
            label: "Rename chat",
            key: "rename-chat",
            onClick: () => setShowModalEditScenario(true),
            disabled: scenarioKey === 'null'
        },
        {
            label: "Delete chat",
            key: "delete-chat",
            onClick: () => setShowModalDeleteScenario(true),
            disabled: scenarioKey === 'null'


        }

    ]


    //     label: <SettingOutlined style={{


    const items: MenuProps['items'] = [
        {
            label: <TitleMedusa
                style={{
                    // height: '90%',
                    padding: '5%',
                }}
            />,
            key: 'home'
        },
        {
            label: <Menu
                items={menuItems}
            />,
            key: 'menu',
        }

    ]



    async function sendMessage() {
        const tmpPrompt = prompt
        setPrompt('') // restart prompt input
        if (prompt === '') {
            return
        }

        let tmpMessages = messages
        tmpMessages = tmpMessages.concat(
            {role: 'user', content: tmpPrompt})
        let tmpMessages_ = tmpMessages.concat(
            {role: 'loading', content: ''})
        setMessages(tmpMessages_)
        const data = await fetchBackendToken(
            `predict_sample?tool_choice=code_interpreter&sampling=${sampling}`,
            {
                method: "post",
                body: JSON.stringify(tmpMessages)
            }
        )
        if (data === null) {
            tmpMessages = tmpMessages.concat(
                {role: 'assistant', content: 'Error calling the model'})
            setMessages(tmpMessages)
            return null
        }


        tmpMessages = data
        setMessages(tmpMessages)

        tmpMessages_ = tmpMessages.concat(
            {role: 'loading', content: ''})
        setMessages(tmpMessages_)

        let content = ''
        for await (
            let chunk of fetchBackendTokenStream(
            `predict_stream?sampling=${sampling}`,
            {
                method: "post",
                body: JSON.stringify(tmpMessages)
            }
        )) {

            content = content + chunk
            tmpMessages_ = tmpMessages.concat(
                {role: 'assistant', content: content}
            )
            setMessages(tmpMessages_)
        }

        tmpMessages = tmpMessages_

        await fetchBackendToken(`add_scenario?scenario_key=${scenarioKey}`, {
            method: "post",
            body: JSON.stringify({
                messages: tmpMessages
            })
        })


    }

    // const columnNames = ['type', 'show_id', 'title'];


    let spanChat = 12
    let spanTable = 12
    if (display === 'left') {
        spanChat = 0
        spanTable = 24
    } else if (display === 'right') {
        spanChat = 24
        spanTable = 0

    }

    const tableItems: TabsProps['items'] = [
        {
            key: '1',
            label: 'Table',
            children: <CustomTable
                data={data}
                ellipsis

            />
        },
        {
            key: '2',
            label: 'Schema',
            children: <CustomTable
                data={schema}
                ellipsis

            />
        },
        // {
        //     key: '3',
        //     label: 'Categories',
        //     children: <CustomTable
        //         data={categories}
        //         ellipsis
        //
        //     />
        // }
    ]

    return (
        <>

            <CustomSider items={items}/>

            <Content className="content"
                     style={{
                         backgroundColor: 'transparent',
                         height: '100vh',
                         display: 'flex',
                         flexDirection: 'column',
                         justifyContent: 'space-between',
                     }}>

                <div className="top"
                     style={{
                         overflow: 'auto',
                         // width: '100%',
                         // maxHeight: '80vh',
                     }}
                >
                    <Row
                        gutter={80}
                        style={{
                            width: '99%',
                            marginLeft: '0.7%',

                        }}>
                        <Col span={spanChat}>
                            <ChatMessages messages={messages}/>
                        </Col>
                        <Col span={spanTable}>
                            {data !== null &&
                                // <LargeSpin/> :
                                <Tabs
                                    items={tableItems}/>

                            }
                        </Col>
                    </Row>
                </div>
                <ChatInput prompt={prompt} setPrompt={setPrompt} sendMessage={sendMessage}/>


                <Modal
                    title='Delete chat?'
                    open={showModalDeleteScenario}
                    onOk={async () => {
                        await deleteScenario(scenarioKey)
                        setShowModalDeleteScenario(false)
                    }}
                    okText='Delete'
                    okButtonProps={{danger: true}}
                    onCancel={() => setShowModalDeleteScenario(false)}
                >
                    Are you sure you want to delete this chat?
                </Modal>
                <Modal
                    title='Rename chat?'
                    open={showModalEditScenario}
                    onOk={async () => {
                        await formEditScenario.submit()
                        const newScenarioKey = formEditScenario.getFieldValue('inputField')
                        await editScenario(scenarioKey, newScenarioKey)
                        setShowModalEditScenario(false)
                    }}
                    okText='Rename'
                    onCancel={() => setShowModalEditScenario(false)}
                >
                    <Form form={formEditScenario}>
                        <Form.Item
                            name='inputField'
                            rules={[
                                {
                                    validator: async (_, value) =>
                                        value && value.length > 3 ? await Promise.resolve() : await Promise.reject(new Error('Input must be at least 3 characters long'))
                                }
                            ]}
                        >
                            <Input placeholder='chat name'/>
                        </Form.Item>
                    </Form>
                </Modal>
            </Content>
        </>
    )
}

export default App